import React, { useEffect, useMemo, useState } from 'react';

// core components
import SubgroupView from '../../common/SubgroupView';
import DescriptionLayer from '../../common/DescriptionLayer';
import DocumentItem from './DocumentItem';
import ConditionalItem from './ConditionalItem';
import QuestionItem from './QuestionItem';
import RiskAssessmentItem from './RiskAssessmentItem';

// Redux
import { connect } from 'react-redux';
import SubgroupTabs from '../../common/SubgroupTabs';
import LoadingState from 'components/new_components/LoadingState';

//translation
import { useTranslation } from 'react-i18next';
import Pciscans from './Pciscans';
import VendorAssessment from './VendorAssessment';

const SubCriterias = (props) => {
    const {
        goBack,
        criteria,
        all_sector,
        loading,
        formPayload,
        merchantResources,
        all_forms_by_subcriteria,
        all_tools_items,
        documents_by_subcriteria,
        all_conditional_forms,
        all_merchant_documents,
        all_condition_answers,
        touchedFields,
        user_cii_tools,
        setFormPayload,
        condtitionalPayload,
        getSubCriteriaQuestion,
        handleResourceExempted,
        getSubCriteriaDocumentsByTag,
        index,
    } = props;
    const [page, setPage] = useState(1);
    const [selectedSubcriteriaNo, setselectedSubcriteriaNo] = useState(null);
    const [document_id, setDocument_id] = useState('');

    //translation
    const { t } = useTranslation('compliance');
    const language = localStorage.getItem('i18nextLng');

    const handleSubgroupChange = (id) => {
        setselectedSubcriteriaNo(id);
        goToNextResource(1);
    };

    // Documents and forms
    const question_forms = all_forms_by_subcriteria?.filter(
        (conditional) => conditional.cii_subsector === selectedSubcriteriaNo
    );
    const conditional_forms = all_conditional_forms?.filter(
        (conditional) => conditional.cii_subsector === selectedSubcriteriaNo
    );
    const document_only = documents_by_subcriteria?.filter(
        (doc) => (doc?.type === '' || doc.type === null) && doc?.cii_subsector === selectedSubcriteriaNo
    );

    const risk_assessment = all_tools_items?.filter(
        (category) => category?.cii_subsector === selectedSubcriteriaNo && category?.category === 'risk assessment'
    );
    const pci_scans = all_tools_items?.filter(
        (category) => category?.cii_subsector === selectedSubcriteriaNo && category?.category === 'pci scan'
    );
    const vendor_assessment = all_tools_items?.filter(
        (category) => category?.cii_subsector === selectedSubcriteriaNo && category?.category === 'vendor assessment'
    );

    const data = (document_only || [])?.concat(
        question_forms,
        conditional_forms,
        risk_assessment,
        pci_scans,
        vendor_assessment
    );

    const filteredData = data?.filter((dat) => dat != undefined);

    // // functions
    const goToNextResource = (page) => {
        if (page <= filteredData?.length) {
            setPage(page);
        }
    };
    const selectedRequirement = useMemo(
        () => all_sector?.find((onecriteria) => onecriteria?.id === criteria),
        [criteria, all_sector]
    );

    const subCriterias = useMemo(() => {
        return selectedRequirement?.subsectors?.length
            ? selectedRequirement?.subsectors
                  ?.sort((a, b) => a?.id - b?.id)
                  ?.map((subRequirement) => ({
                      id: subRequirement?.id,
                      title: subRequirement?.name,
                      description: subRequirement?.description,
                      criteria: subRequirement?.cii_sector,
                      contain_tools: subRequirement?.contain_tools,
                      contain_risk: subRequirement?.contain_risk,
                  }))
            : [];
    }, [selectedRequirement]);

    useEffect(() => {
        if (subCriterias) {
            const activeSubrequirement = subCriterias?.find((sub) => sub?.id);
            if (activeSubrequirement) {
                setselectedSubcriteriaNo(activeSubrequirement?.id);
            } else {
                goBack();
            }
        }
    }, [subCriterias]);

    useEffect(() => {
        if (selectedSubcriteriaNo) {
            getSubCriteriaQuestion(selectedSubcriteriaNo);
            getSubCriteriaDocumentsByTag(selectedSubcriteriaNo);
        }
    }, [selectedSubcriteriaNo]);

    // get documents and forms that have been attended to
    const documentAttendedTo = useMemo(() => {
        return document_only?.length
            ? document_only?.map((subReqDoc) => {
                  return all_merchant_documents?.some(
                      (merchDoc) => merchDoc?.document_id === subReqDoc?.id && merchDoc?.tag === null
                  );
              })
            : null;
    }, [all_merchant_documents, document_only]);

    const formResourcesHaveBeenAttendedTo = useMemo(() => {
        return question_forms?.length
            ? question_forms?.map((subReqDoc) => {
                  return merchantResources?.some((merchDoc) => merchDoc?.form_id === subReqDoc?.id);
              })
            : null;
    }, [merchantResources, question_forms]);

    const conditionalResourcesHaveBeenAttendedTo = useMemo(() => {
        return conditional_forms?.length
            ? conditional_forms?.map((subReqDoc) => {
                  return all_condition_answers?.some((merchDoc) => merchDoc?.cii_conditional === subReqDoc?.id);
              })
            : null;
    }, [all_condition_answers, conditional_forms]);

    const riskAssessmentHaveBeenAttendedTo = useMemo(() => {
        return risk_assessment?.length
            ? risk_assessment?.map((subReqDoc) => {
                  return user_cii_tools?.some((merchDoc) => merchDoc?.id === subReqDoc?.id);
              })
            : null;
    }, [user_cii_tools, risk_assessment]);

    const pciScansHaveBeenAttendedTo = useMemo(() => {
        return pci_scans?.length
            ? pci_scans?.map((subReqDoc) => {
                  return user_cii_tools?.some((merchDoc) => merchDoc?.id === subReqDoc?.id);
              })
            : null;
    }, [user_cii_tools, pci_scans]);

    const vendorAssessmentHaveBeenAttendedTo = useMemo(() => {
        return vendor_assessment?.length
            ? vendor_assessment?.map((subReqDoc) => {
                  return user_cii_tools?.some((merchDoc) => merchDoc?.id === subReqDoc?.id);
              })
            : null;
    }, [user_cii_tools, vendor_assessment]);

    const resourcesHaveBeenAttendedTo = (documentAttendedTo === null ? [] : documentAttendedTo)?.concat(
        formResourcesHaveBeenAttendedTo,
        conditionalResourcesHaveBeenAttendedTo,
        riskAssessmentHaveBeenAttendedTo,
        pciScansHaveBeenAttendedTo,
        vendorAssessmentHaveBeenAttendedTo
    );

    const filteredResourcesHaveBeenAttendedTo = resourcesHaveBeenAttendedTo?.filter(
        (resource) => resource !== null && resource !== undefined
    );

    const subCriteriatCompletionPercent = useMemo(() => {
        return (
            (filteredResourcesHaveBeenAttendedTo?.reduce((prev, curr) => prev + (curr ? 1 : 0), 0) * 100) /
            filteredResourcesHaveBeenAttendedTo?.length
        );
    }, [filteredResourcesHaveBeenAttendedTo]);

    const selectedResource = useMemo(() => {
        return filteredData?.[page - 1];
    }, [filteredData, page]);

    const selectedCategory = all_sector?.find((data) => data.id === criteria);
    const selectedSubCriteria = subCriterias?.find((data) => data.id === selectedSubcriteriaNo);

    const checkCompleted = (item) => {
        return item === true || item?.value === true;
    };
    const completed = filteredResourcesHaveBeenAttendedTo?.every(checkCompleted);

    const resource = selectedResource?.no_label ? 'conditional' : 'form';

    // On resource change
    const onResourceChange = () => {
        handleResourceExempted(selectedSubcriteriaNo);
        if (page > 1) {
            setPage(page - 1);
        } else {
            setPage(1);
        }
    };

    useEffect(() => {
        if (resource === 'form') {
            const adminResource = selectedResource;
            const merchantResource = merchantResources?.length
                ? merchantResources
                      ?.sort((a, b) => b?.id - a?.id)
                      ?.find((resource) => resource?.form_id === adminResource?.id)
                : {};
            let initialValues = {},
                requiredValues = {};
            adminResource?.form_fields?.forEach((field) => {
                initialValues[field?.id] = merchantResource?.answer?.[field?.id] || '';
                requiredValues[field?.id] = field?.required;
            });
            setFormPayload({
                values: initialValues,
                form_id: adminResource?.id,
                cii_subsector: selectedSubcriteriaNo,
                resource,
                requiredValues,
            });
        } else {
            const merchantResource = all_condition_answers?.length
                ? all_condition_answers
                      ?.sort((a, b) => b?.id - a?.id)
                      ?.find((resource) => resource?.cii_conditional === selectedResource?.id)
                : {};
            let initialValues = {};
            initialValues['answer'] = merchantResource?.answer || '';
            initialValues['no_label'] = merchantResource?.form_answer || '';
            initialValues['id'] = selectedResource?.id || '';
            setFormPayload({
                values: initialValues,
                cii_subsector: selectedSubcriteriaNo,
                cii_conditional: selectedResource?.id,
                resource,
                criteria,
                document_id: document_id,
            });
        }
    }, [selectedResource, merchantResources, resource]);

    return (
        <SubgroupView
            goBack={goBack}
            title={selectedCategory.name}
            currentResourcePage={page}
            data={filteredResourcesHaveBeenAttendedTo}
            goToNextResource={goToNextResource}
            submitting={loading.submit}
            touchedFields={touchedFields}
            resource={selectedResource?.question || selectedResource?.form_fields ? 'form' : 'doc'}
            selectedSubcriteriaNo={selectedSubcriteriaNo}
            standard="blockchain"
        >
            <SubgroupTabs
                subgroups={subCriterias}
                onSubgroupChange={handleSubgroupChange}
                selectedSubgroup={selectedSubcriteriaNo}
                selectedSubCriteria={selectedSubCriteria}
                selectedResource={selectedResource}
                selectedSubcriteriaNo={selectedSubcriteriaNo}
                criteria={criteria}
                completed={completed}
                isCii
            />
            {loading.content ? (
                <LoadingState />
            ) : (
                <>
                    <DescriptionLayer
                        percentCompletion={subCriteriatCompletionPercent}
                        label={`${t('sub')} ${selectedSubCriteria?.title} ${t('completion')}`}
                        description={selectedSubCriteria?.description}
                    />
                    {selectedResource?.default && (selectedResource?.type === '' || selectedResource?.type === null) ? (
                        <DocumentItem
                            title={
                                language?.includes('fr')
                                    ? selectedResource?.criteria_title_fr
                                    : language?.includes('en')
                                    ? selectedResource?.criteria_title_en
                                    : selectedResource?.criteria_title
                            }
                            document={selectedResource}
                            onResourceChange={onResourceChange}
                            no_excemption={index === 1}
                        />
                    ) : selectedResource?.question ? (
                        <ConditionalItem
                            form={selectedResource}
                            setDocument_id={setDocument_id}
                            formPayload={formPayload}
                            onResourceChange={onResourceChange}
                            condtitionalPayload={condtitionalPayload}
                            documnetId={document_id}
                            no_excemption={index === 1}
                        />
                    ) : selectedResource?.form_fields ? (
                        <QuestionItem
                            form={selectedResource}
                            onResourceChange={onResourceChange}
                            no_excemption={index === 1}
                        />
                    ) : selectedResource?.category === 'risk assessment' ? (
                        <RiskAssessmentItem
                            risk_assessment={selectedResource}
                            onResourceChange={onResourceChange}
                            no_excemption={index === 1}
                        />
                    ) : selectedResource?.category === 'pci scan' ? (
                        <Pciscans
                            pci={selectedResource}
                            onResourceChange={onResourceChange}
                            no_excemption={index === 1}
                        />
                    ) : selectedResource?.category === 'vendor assessment' ? (
                        <VendorAssessment
                            assessment={selectedResource}
                            onResourceChange={onResourceChange}
                            no_excemption={index === 1}
                        />
                    ) : null}
                </>
            )}
        </SubgroupView>
    );
};

const mapStateToProps = (state) => {
    return {
        all_sector: state?.adminReducers?.all_sector,
        documents_by_subcriteria: state?.adminReducers?.subsector_documents,
        all_forms_by_subcriteria: state?.adminReducers?.admin_cii_forms,
        all_merchant_documents: state?.complianceReducers?.all_merchant_documents,
        all_condition_answers: state?.complianceReducers?.all_cii_condition_answers,
        all_conditional_forms: state?.adminReducers?.admin_cii_conditional_items,
        all_criteria_summary: state?.complianceReducers?.cii_summary,
        all_tools_items: state?.adminReducers?.all_cii_tools_items,
        user_cii_tools: state?.adminReducers?.user_cii_tools,
    };
};
export default connect(mapStateToProps, {})(SubCriterias);
